import Container from "./Container";
import {useEffect, useState} from "react";
import Fadeout from "./Fadeout";

export default function Hero({image, bgPosition = 'center', children, size = 'big'}) {
    const [background, setBackground] = useState(null);

    useEffect(() => {
        // todo: use srcset like a sane person
        const handleResize = () => {
            if (window.innerWidth >= 1024) {
                setBackground(`/img/hero/${image}_desktop.jpg`);
            } else if (window.innerWidth >= 600) {
                setBackground(`/img/hero/${image}_tablet.jpg`);
            } else {
                setBackground(`/img/hero/${image}_mobile.jpg`);
            }
        };

        window?.addEventListener('resize', handleResize);
        handleResize();

        return () => window?.removeEventListener('resize', handleResize);
    }, [image]);

    // force Tailwind to generate the classes
    const classes = "md:h-hero-big md:h-hero-medium md:h-hero-narrow";

    return (
        <section
            className={`mx-auto relative ${size !== 'narrow' ? 'h-hero-small' : 'h-hero-narrow'} md:h-hero-${size} bg-black text-white overflow-hidden pb-16 md:pb-0`}>
            <div className="absolute h-full w-full top-0 left-1/2 -translate-x-1/2 max-w-[1400px]">
                {/* todo: use <Image/> */}
                <div style={background ? {backgroundImage: `url(${background})`} : null}
                     className={`w-full h-full bg-${bgPosition} lg:bg-center bg-cover bg-no-repeat`}/>

                <Fadeout direction="top" color="black" className="w-full h-2/3 md:hidden"/>

                <Fadeout direction="right" color="black" className="hidden md:block w-[400px]"/>
                <Fadeout direction="left" color="black" className="hidden xl:block w-[400px]"/>
            </div>

            <Container className="relative h-full flex items-end md:items-center">
                {children}
            </Container>
        </section>
    )
}
